import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

export const mmtc_sell_requestApi = createAsyncThunk("mmtc_sell_request", async ({ startDate = null, endDate = null }) => {
  
  const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
  const response = await axiosInstance.get("/mmtc_sell_request",{ params });
  return response.data;
});

const mmtc_sell_requestSlice = createSlice({
  name: "mmtc_sell_request",
  initialState: {
    mmtc_sell_request: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(mmtc_sell_requestApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(mmtc_sell_requestApi.fulfilled, (state, action) => {
        state.mmtc_sell_request = action.payload;
        state.loading = false;
      })
      .addCase(mmtc_sell_requestApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default mmtc_sell_requestSlice.reducer;
